import React from 'react'
import { Redirect } from 'react-router-dom'
import routes from '../config/settings/routes'

/**
 * The Home' page.
 */
const Home = () => {
  return (
    <Redirect to={routes.login} />
  )
}

export default Home
